import { cacheTypes, getMethodByDispatcher, setErrorDialog, serverUrl, getheader, postMethodByDispatcher } from "../../../store/api/CommonFunctions";

export function getPreCustomerExtAttrSettings() {
    return dispatch => {
        fetch(serverUrl + "api/SystemSetting/GetPreCustomerExtSettings", {
            headers: getheader(),
            method: "GET",
            cache: "default"
        }).then(res => res.json())
            .then(res => {
                if (res.Message === "Error") {
                    res = [];
                }
                return dispatch({
                    type: "GET_PRECUSTOMER_EXT_SETTINGS",
                    data: res
                })
            }).catch(e => {
                console.log("[GET_PRECUSTOMER_EXT_SETTINGS] ", e);
                return dispatch({
                    type: "GET_PRECUSTOMER_EXT_SETTINGS",
                    data: []
                })
            });
    }
}
export function getCustomerExtAttrSettings() {
    return dispatch => dispatch(getMethodByDispatcher(`api/SystemSetting/GetCustomerExtSettings`, "GET_CUSTOMER_EXT_SETTINGS", cacheTypes.NoCache, "تنظیمات مشتریان"))
}
export function getSystemSettings(data, onGet) {
    return dispatch => {
        dispatch(postMethodByDispatcher("api/SystemSetting/GetSystemSettings", data, "GET_SYSTEM_SETTINGS", "تنظیمات سیستم", onGet))
    }
}
export function getPrintTemplate(templateName) {
    return dispatch => {
        dispatch({
            type: "GET_PRINT_TEMPLATE",
            data: "PENDING"
        });
        fetch(serverUrl + "api/PrintTemplateAPI/GetTemplate?templateName=" + templateName, {
            headers: getheader(),
            method: "GET",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                if (res === "Error" || res.Message) {
                    res = null;
                }
                dispatch({
                    type: "GET_PRINT_TEMPLATE",
                    data: res
                });
            })
    }
}
export function setPrintViewerPopStatus(status) {
    return dispatch => {
        dispatch({
            type: "PRINT_VIEW_POPSTATUS",
            data: status
        });
    }
}
export function checkSystemVersion() {
    return dispatch => {
        fetch(serverUrl + "api/SystemSetting/CheckSystemVersion", {
            method: "GET",
            headers: getheader(),
            cache: "default"
        }).then(res => res.json()).then(res => dispatch({ type: "CHECK_VERSION", data: res }));
    }
}
export function saveSystemSettings(data, fn) {
    return dispatch => {
        fetch(serverUrl + "api/SystemSetting/SaveSystemSettings", {
            headers: getheader(),
            method: "POST",
            body: JSON.stringify(data)
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "ذخیره تنظیمات");
                    return;
                }
                setErrorDialog(dispatch, "success", "ذخیره تنظیمات");
                dispatch({
                    type: "GET_SYSTEM_SETTINGS",
                    data: res
                });
                if (fn) {
                    fn();
                }
            }).catch(e => console.log("[SAVE_SYSTEM_SETTINGS]", e));
    }
}